import type { ReactNode } from "react";
import { memo } from "react";
import { Navigate } from "react-router-dom";

import { Toaster as Sonner } from "@/components/ui/sonner";

import { ThemeProvider } from "../components/ui/theme-provider";
import { useAdminPanelEnabled } from "../hooks/use-admin-panel-enabled";
import { AdminRoutes } from "./AdminRoutes";

// NOTE: Gates admin routes behind the backend isAdminPanelEnabled flag.
// NOTE: Returns null while loading to prevent fallthrough to regular app routes.
const AdminGate = (): ReactNode => {
  const { isAdminPanelEnabled, isLoading } = useAdminPanelEnabled();

  if (isLoading) {
    return null;
  }

  if (!isAdminPanelEnabled) {
    return <Navigate to="/" replace />;
  }

  return (
    <ThemeProvider isOrgBrandingEnabled={false}>
      <Sonner />
      <AdminRoutes />
    </ThemeProvider>
  );
};

export default memo(AdminGate);
